'use strict';

var Cookies = require('cookies-js');
var lodash = require('lodash');

var memoryStorage = {
    wenData: {}
};

//yuck.. https://gist.github.com/paulirish/5558557 only "real" way to check if LS is available
function isLocalStorageAvailable() {
    try {
        localStorage.setItem('test', 'val');
        localStorage.removeItem('test');
        return true;
    } catch (e) {
        return false;
    }
}

/**
 * Wendys Storage Class
 * @param {object} cookieOptions - options for cookies
 * @param {string} globalStoreId - cookie name used for global store
 * @constructor
 * @description Managing class for local and cookie storage
 */
function WenStorage(cookieOptions, globalStoreId) {
    if (isLocalStorageAvailable() && !localStorage.wenData) {
        localStorage.wenData = JSON.stringify({});
    }

    var storeId = globalStoreId === undefined ? 'wenGlobalWeb' : globalStoreId;
    this.local = new Local();
    this.global = new Global(cookieOptions, storeId);
}

/**
 * Local Storage Manager
 * @constructor
 * @description Local storage management. Will attempt to use localStorage
 * if available; otherwise will use memoryStorage object
 */
function Local() {
    this.get = function (key) {
        return typeof localStorage !== 'undefined' && localStorage.wenData ? JSON.parse(localStorage.wenData)[key] || false : memoryStorage['wenData'][key] || false;
    };

    this.set = function (key, value) {
        if (isLocalStorageAvailable()) {
            var dataString = localStorage.wenData;
            var data = JSON.parse(dataString) || {};
            data[key] = value;
            dataString = JSON.stringify(data);
            localStorage.wenData = dataString;
        } else {
            var data = memoryStorage['wenData'];
            data[key] = value;
            memoryStorage['wenData'] = data;
        }
    };

    this.delete = function (key) {
        if (isLocalStorageAvailable()) {
            var dataString = localStorage.wenData;
            var data = JSON.parse(dataString);
            delete data[key];
            dataString = JSON.stringify(data);
            localStorage.wenData = dataString;
        } else {
            delete memoryStorage['wenData'][key];
        }
    };

    this.clear = function () {
        if (isLocalStorageAvailable()) {
            localStorage.wenData = JSON.stringify({});
        } else {
            memoryStorage['wenData'] = {};
        }
    };
};

/**
 * Global Storage Manager
 * @param cookieOptions
 * @param globalStoreId
 * @constructor
 * @description Cookie Management
 */
function Global(cookieOptions, globalStoreId) {
    this.enable = typeof Cookies.get != 'undefined';
    this.storeId = globalStoreId; //--declared for verbosity : default value is 'wenGlobal'

    this.get = function (key) {
        if (this.enable) {
            var dataString = Cookies.get(this.storeId) || false;
            var data = JSON.parse(dataString);
            return data[key] || false;
        }
        return false;
    };

    this.set = function (key, value) {
        if (this.enable) {
            var dataString = Cookies.get(this.storeId);
            var data = dataString ? JSON.parse(dataString) : {};
            data[key] = value;
            dataString = JSON.stringify(data);
            Cookies.set(this.storeId, dataString, cookieOptions);
        }
        return false;
    };

    this.delete = function (key) {
        if (this.enable) {
            var dataString = Cookies.get(this.storeId);
            var data = dataString ? JSON.parse(dataString) : {};
            delete data[key];
            dataString = JSON.stringify(data);
            Cookies.set(this.storeId, dataString, cookieOptions);
        }
        return false;
    };

    this.clear = function () {
        if (this.enable) {
            var dataString = JSON.stringify({});
            Cookies.set(this.storeId, dataString, cookieOptions);
        }
    };
};

//TODO: eventually remove this constructor export after all projects are updated
module.exports = new WenStorage({});

/**
 * Use this method to gain more control of how cookies are created and managed for your site.
 * @param {object} options - options for cookies
 * @param {string} globalStoreId - cookie name used for global store
 */
module.exports.createStorage = function (options, globalStoreId) {
    var storeId = globalStoreId === undefined ? 'wenGlobalWeb' : globalStoreId;
    return new WenStorage(options, storeId);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/storage.js
// module id = 326
// module chunks = 0